import { detailed } from './detailed';
import { general } from './general';

export const stats = {
  namespaced: true,
  modules: {
    detailed,
    general
  }
};
